import { render, staticRenderFns } from "./UploadItem.vue?vue&type=template&id=be0d9a1a"
import script from "./UploadItem.vue?vue&type=script&lang=js"
export * from "./UploadItem.vue?vue&type=script&lang=js"
import style0 from "./UploadItem.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports